import { render, staticRenderFns } from "./WorkCalendarSidebar.vue?vue&type=template&id=c9fda6be&scoped=true"
import script from "./WorkCalendarSidebar.vue?vue&type=script&lang=js"
export * from "./WorkCalendarSidebar.vue?vue&type=script&lang=js"
import style0 from "./WorkCalendarSidebar.vue?vue&type=style&index=0&id=c9fda6be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fda6be",
  null
  
)

export default component.exports